export function addSlideClass(selector) {
	[...selector.querySelector(".swiper-wrapper").children].forEach((element) => {
		element.classList.add("swiper-slide");
	});
}
